export default __webpack_public_path__ + "static/media/lifestyle-sample-1.f94184b9.png";